export default __webpack_public_path__ + "static/media/mail_icon.fea8c720.svg";